/* o’po’stro’phe: the phone's sticky buy button (owner 1379, 2026-10-31: "is there not a highly optimal high conversions presentation?").
   While the page's own buy button is still below the screen, the same button waits at the bottom edge. It mirrors the real
   button (label, price, disabled state) and does exactly what it does: with no size picked it brings the sizes into view and
   nudges them; with a size picked it presses the real button. Phones only; it never shows once the real button is in view or
   passed, after an add, or inside the home sheet's rooms. */
(function () {
  if (!window.matchMedia || !window.IntersectionObserver || !window.MutationObserver) return;
  var phone = window.matchMedia('(max-width: 749px)');
  var main = document.querySelector('[data-o-lineup-get]') || document.querySelector('[data-o-get]');
  if (!main) return;
  var sizes = document.querySelector('[data-o-lineup-sizes]') || document.querySelector('[data-o-sizes]');
  var paper = document.querySelector('.o-paper');

  var css = document.createElement('style');
  css.textContent = '.o-sticky{position:fixed;z-index:60;left:16px;right:16px;bottom:calc(10px + env(safe-area-inset-bottom,0px));' +
    'box-shadow:0 6px 24px rgb(0 0 0 / 0.18);transition:transform .2s ease,opacity .2s ease}' +
    '.o-sticky[hidden]{display:block!important;transform:translateY(140%);opacity:0;pointer-events:none}' +
    '.o-sticky>button{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;min-height:52px;margin:0;' +
    'padding:13px 18px;border:0;border-radius:0;font-family:"American Typewriter","Courier New",Courier,monospace;font-size:19px;line-height:1.1;cursor:pointer}' +
    '@media (prefers-reduced-motion: reduce){.o-sticky{transition:none}}';
  document.head.appendChild(css);

  var bar = document.createElement('div');
  bar.className = 'o-sticky'; bar.hidden = true; bar.setAttribute('aria-hidden', 'true');
  var btn = document.createElement('button');
  btn.type = 'button'; btn.tabIndex = -1;
  btn.className = String(main.className || '').replace(/\bis-[\w-]+/g, '').trim();
  bar.appendChild(btn); document.body.appendChild(bar);

  function sync() {
    btn.innerHTML = main.innerHTML; btn.disabled = !!main.disabled;
    // the bar lives outside the section, so it copies the real button's computed look (its colours come from section variables)
    try { var cs = getComputedStyle(main); btn.style.background = cs.backgroundColor; btn.style.color = cs.color; btn.style.boxShadow = cs.boxShadow; btn.style.fontSize = cs.fontSize; } catch (err) {}
  }
  sync();
  new MutationObserver(sync).observe(main, { subtree: true, childList: true, characterData: true, attributes: true });

  var below = false, pickerOn = false;
  function show() {
    var off = !phone.matches || !below || pickerOn || main.offsetParent === null || (paper && paper.classList.contains('is-room'));
    bar.hidden = off;
  }
  new IntersectionObserver(function (es) {
    var e = es[es.length - 1];
    below = !e.isIntersecting && e.boundingClientRect.top > 0;
    show();
  }, { threshold: 0 }).observe(main);
  // 2026-11-02: the bar stays off while the size row is on screen, so it never covers the colour chips or the long-sleeve row on short phones
  var sizes = document.querySelector('[data-o-sizes], .o-lineup__sizes');
  if (sizes) new IntersectionObserver(function (es) { pickerOn = es[es.length - 1].isIntersecting; show(); }, { threshold: 0 }).observe(sizes);
  if (paper) new MutationObserver(show).observe(paper, { attributes: true, attributeFilter: ['class'] });
  var form = main.form || main.closest('form');
  if (form) new MutationObserver(show).observe(form, { attributes: true, attributeFilter: ['class'] });
  if (phone.addEventListener) phone.addEventListener('change', show);

  btn.addEventListener('click', function () {
    var label = (main.textContent || '').toLowerCase();
    if (/pick a size/.test(label) && sizes) {
      try { sizes.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { sizes.scrollIntoView(); }
      setTimeout(function () { main.click(); }, 450);
      return;
    }
    main.click();
  });
})();
